import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-signed-out',
  templateUrl: './signed-out.component.html',
  styleUrls: ['./signed-out.component.css'],
  standalone: false
})
export class SignedOutComponent {
  readonly signInUrl = environment.appUrl;
}
